import PostProcessRT from './postProcessRT'
import Rendable from '@/glxp/abstract/rendable'
import Shader from '@/glxp/utils/shader'
import Colors from '../color'

import ShaderManifest from '../entities/shaderManifest'
import PingPongPass from './pass/marblingDisplacePingPongPass'

const VERTICES = [-1, 1, 0, -1, -1, 0, 1, -1, 0, 1, 1, 0]
const INDICES = [0, 1, 2, 0, 2, 3]
const UVS = [
  0, 1,
  0, 0,
  1, 0,
  1, 1
]

class Post extends Rendable {
  constructor (scene) {
    super(scene)
    this.hasNormal = false
    // this.onlyVertices = false

    this.floatTextureEnabled = false // Texture Float

    var shader = new Shader(ShaderManifest['marbling-post'], 4)
    this.initProgram(shader.vert, shader.frag)
    this.initBuffer({
      vertices: VERTICES,
      uvs: UVS,
      indices: INDICES
    })
    this.initVao()
    this.createUniforms()

    this.rt = new PostProcessRT(this.scene)

    if (this.floatTextureEnabled) {
      this.pass = new PingPongPass(this.scene, shader, false)
    } else {
      this.pass = new PingPongPass(this.scene, shader, false, false,  [ 1,  0])
      this.pass1 = new PingPongPass(this.scene, shader, false, false, [ 0,  1])
      this.pass2 = new PingPongPass(this.scene, shader, false, false, [-1,  0])
      this.pass3 = new PingPongPass(this.scene, shader, false, false, [ 0, -1])
    }
  }

  createUniforms () {
    this.createUniform('uTexture', 'texture')
    this.createUniform('uPass', 'texture')
    this.createUniform('uPass1', 'texture')
    this.createUniform('uPass2', 'texture')
    this.createUniform('uPass3', 'texture')
    this.createUniform('uRez', 'float2')
    this.createUniform('uMarginScale')
    this.createUniform('uFloatTextureEnabled')
  }

  applyState () {
    let gl = this.gl
    this.scene.applyDefaultState()
    gl.disable(gl.DEPTH_TEST)
    // gl.disable(gl.BLEND)
  }

  preRender () {
    this.rt.preRender()
  }

  postRender () {
    this.rt.postRender()
  }

  render () {
    let gl = this.gl

    this.pass.render()
    if (this.floatTextureEnabled == false) {
      this.pass1.render()
      this.pass2.render()
      this.pass3.render()
    }

    gl.useProgram(this.program)
    gl.bindVertexArray(this.vao)
    this.applyState()

    gl.activeTexture(gl.TEXTURE0)
    this.rt.bind()
    this.bindUniform('uTexture', 0)

    gl.activeTexture(gl.TEXTURE1)
    this.pass.bind()
    this.bindUniform('uPass', 1)
    
    if (this.floatTextureEnabled == false) {
      gl.activeTexture(gl.TEXTURE2)
      this.pass1.bind()
      this.bindUniform('uPass1', 2)

      gl.activeTexture(gl.TEXTURE3)
      this.pass2.bind()
      this.bindUniform('uPass2', 3)

      gl.activeTexture(gl.TEXTURE4)
      this.pass3.bind()
      this.bindUniform('uPass3', 4)
    }

    this.bindUniform('uMarginScale', 1)
    this.bindUniform("uFloatTextureEnabled", this.floatTextureEnabled?1:0)
    this.bindUniform('uRez', [this.scene.width, this.scene.height])

    gl.drawElements(gl.TRIANGLES, INDICES.length, gl.UNSIGNED_SHORT, 0)
    gl.bindVertexArray(null)
  }
}

export default Post
